var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('el-col', {
    staticStyle: {
      "padding-right": "1%"
    },
    attrs: {
      "span": 21
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding-left": "1%"
    },
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%",
      "border-color": "#006E48",
      "background-color": "#006E48",
      "color": "#FFFFFF"
    },
    on: {
      "click": _vm.query
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "550px",
      "overflow-y": "scroll",
      "width": "100%",
      "border-top": "1px solid #EBEEF5"
    }
  }, [_c('el-tree', {
    ref: "tree",
    staticClass: "filter-tree",
    attrs: {
      "props": _vm.defaultProps,
      "lazy": "",
      "load": _vm.loadNode,
      "filter-node-method": _vm.filterNode,
      "highlight-current": true,
      "accordion": _vm.accordion
    },
    on: {
      "node-click": _vm.nodeSelection
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('div', {}, [_c('div', {
          staticStyle: {
            "display": "inline-block",
            "width": "100%"
          }
        }, [_c('el-divider', {
          attrs: {
            "content-position": "left"
          }
        }, [_vm._v(_vm._s(data.organize_name))]), _vm._v(" "), (_vm.type == 'radio') ? _c('el-radio-group', {
          on: {
            "change": function($event) {
              return _vm.handleRadioChange(data.staffList)
            }
          },
          model: {
            value: (_vm.staff_id),
            callback: function($$v) {
              _vm.staff_id = $$v
            },
            expression: "staff_id"
          }
        }, [_c('el-row', {
          staticStyle: {
            "width": "100%",
            "margin-top": "10px"
          }
        }, _vm._l((data.staffList), function(staff) {
          return _c('el-col', {
            key: staff.id,
            staticStyle: {
              "margin-bottom": "5px"
            },
            attrs: {
              "span": 6
            }
          }, [_c('el-radio', {
            attrs: {
              "label": staff.id
            }
          }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(staff.staff_name) + "\n\t\t\t\t\t\t\t\t")])], 1)
        }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'checkbox') ? _c('el-checkbox-group', {
          on: {
            "change": function($event) {
              return _vm.handleCheckboxChangeGroup(data.staffList)
            }
          },
          model: {
            value: (_vm.staff_ids),
            callback: function($$v) {
              _vm.staff_ids = $$v
            },
            expression: "staff_ids"
          }
        }, [_c('el-row', {
          staticStyle: {
            "width": "100%",
            "margin-top": "10px"
          }
        }, _vm._l((data.staffList), function(staff) {
          return _c('el-col', {
            key: staff.id,
            staticStyle: {
              "margin-bottom": "5px"
            },
            attrs: {
              "span": 6
            }
          }, [_c('el-checkbox', {
            attrs: {
              "label": staff.id
            },
            on: {
              "change": function($event) {
                return _vm.handleCheckboxChange(staff)
              }
            }
          }, [_vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(staff.staff_name) + "\n\t\t\t\t\t\t\t\t")])], 1)
        }), 1)], 1) : _vm._e(), _vm._v(" "), _c('hr')], 1)])
      }
    }])
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a542e0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/organizeStaff/organizeStaff.vue
// module id = null
// module chunks = 